import { version } from "../../package.json";
import { UseQueryResult, useQuery } from "react-query";

type AppDetails = {
  version: string;
};

const AppDetailsKeys = {
  all: ["app-details"] as const,
};

const useAppDetails = (): UseQueryResult<AppDetails> => {
  return useQuery<AppDetails>(
    AppDetailsKeys.all,
    async () =>
      await fetch("/app.json").then(
        (response) => response.json() as unknown as AppDetails
      ),
    {
      refetchInterval: 120 * 60 * 1000,
      onSuccess: async (data) => {
        if (data.version != version) {
          await caches
            .keys()
            .then(async (names) => {
              // eslint-disable-next-line functional/no-loop-statement, @typescript-eslint/no-for-in-array
              for (const name of names) {
                await caches.delete(name);
              }
            })
            .finally(() =>
              setTimeout(() => {
                window.location.reload();
              }, 1000)
            );
        }
      },
    }
  );
};

export type { AppDetails };
export { useAppDetails };
